import {
  REGISTRATION_STATUS_LABEL,
  type RegistrationStatus,
} from '@/entities/prescription-registration/api/prescription-registration.api';
import { Badge } from '@/shared/ui';

/** 등록(초록) · 미등록(빨강). size md 는 요약 카드용 */
export function RegistrationStatusBadge({
  status,
  size = 'sm',
}: {
  status: RegistrationStatus;
  size?: 'sm' | 'md';
}) {
  return (
    <Badge tone={status === 'REGISTERED' ? 'success' : 'error'} size={size}>
      {REGISTRATION_STATUS_LABEL[status]}
    </Badge>
  );
}
